<template>
  <div class="content--sinoreg eProtocolo p-1">
    <h4 class="eProtocolo_title">
      Pendência e-Protocolo
    </h4>
    <div class="row mx-0">
      <div class="col-12 p-0">
        <EProtocoloFiltros @results="filtrarProtocolos" />
      </div>
      <div class="col-12 p-0">
        <EProtocoloTable :prop-e-protocolos="protocolos" />
      </div>
    </div>

    <Pagination v-if="protocolos && protocolos.length"
                :per-page="perPage"
                :page="page"
                :last-page="lastPage"
                :select-page="true"
                @onSetPage="(ev) => reloadRelatorios(true, ev)"
                @onPreviousPage="reloadRelatorios(true, page - 1)"
                @onNextPage="reloadRelatorios(true, page + 1)" />
  </div>
</template>

<script>
  /* components */
  import EProtocoloFiltros from '@/components/SofiaRei/EProtocolo/EProtocoloFiltros'
  import EProtocoloTable from '@/components/SofiaRei/EProtocolo/EProtocoloTable'
  import Pagination from "@/components/SofiaRei/Pagination"

  /* services */
  import EProtocoloService from '@/services/EProtocoloService'

  import { mapGetters } from "vuex"

  export default {
    name: 'Pendencia',
    components: {
      EProtocoloFiltros,
      EProtocoloTable,
      Pagination
    },
    data () {
      return {
        cns: null,
        protocolos: [],
        page: 1,
        lastPage: 1,
        perPage: 15,
        filtrosProtocolo: {
          numeroProtocolo: null,
          statusProtocolo: null
        }
      }
    },
    computed: {
      ...mapGetters({
        userCartorios: "auth/getUserCartorios"
      })
    },
    async created () {
      this.cns = this.userCartorios[0].cns
      const response = await EProtocoloService.obterNotificacoes(this.cns)
      this.$store.dispatch('eProtocolo/setTotalNotificacoes', response.data.notificacoes.length)
      
      await this.reloadRelatorios()
    },
    methods: {
      filtrarProtocolos (filters) {
        this.filtrosProtocolo.numeroProtocolo = filters.numeroProtocolo
        this.filtrosProtocolo.statusProtocolo = filters.statusProtocolo
        this.perPage = filters.perPage
        this.page = 1

        this.reloadRelatorios(true, this.page)
      },
      async reloadRelatorios (loaderActive = true, page = 1) {
        try {
          loader({active: loaderActive, text: 'Buscando Notificações'})

          const params = {
            page,
            cns: this.cns,
            perPage: this.perPage,
            filtrosProtocolo: this.filtrosProtocolo
          }

          const response = await EProtocoloService.buscarPendencias(params)
          const { data, page: currentPage, lastPage, perPage } = response.data

          if (data && data.length) {
            this.protocolos = data
            this.page = currentPage
            this.lastPage = lastPage
            this.perPage = perPage
          } else  {
            this.protocolos = []
            this.page = 1
            this.lastPage = 1
            this.perPage = 15

            return displayMessage('error', 'Nenhum protocolo encontrado!')
          }
        } catch (error) {
          displayMessage('error', 'Error!', error.message)
        } finally {
          loader({active: false, text: ''})
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/scss/_utilities/_exports";
  
  .eProtocolo {
      &_title {
        background-color: $sinoreg-blue;
        color: $color-white;
        font-size: pxToRem(24);
        font-weight: 500;
        padding: pxToRem(10) pxToRem(20);
      }

      &_label {
        font-size: pxToRem(16);
      }
    }
</style>